<div class="page-header">
    <h2 class="title text-center">
      <span class="text-capitalize">Motivo de Rechazo de la Solicitud</span>
    </h2>
  </div>
  
  <div class="row">
  
    <div class="col">
      <mat-form-field class="textareaForm">
        <textarea matInput placeholder="Describa la razón del rechazo:" [(ngModel)]="data.comment"></textarea>
      </mat-form-field>
    </div>
  
  </div>
  
  <div class="row">
    <div class="col-md-4 offset-md-4">
      <button class="btn btn-outline-secondary btn-block" (click)="onNoClick()">cancelar</button>
    </div>
  
    <div class="col-md-4">
      <button class="btn btn-block btn-primary" [mat-dialog-close]="data">Rechazar</button>
    </div>
  
  </div>